export {default} from './Teams';



// WEBPACK FOOTER //
// ./src/pages/Teams/index.ts